export default "__VITE_ASSET__BP1bW$zk__"